import script from "./DocumentContent.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentContent.vue?vue&type=script&setup=true&lang=js"

import "./DocumentContent.vue?vue&type=style&index=0&id=e6d3b982&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e6d3b982"]])

export default __exports__